'use strict';

module.exports = require('./Autosuggest').default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-autosuggest/dist/index.js
 ** module id = 1136
 ** module chunks = 0
 **/